
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const ApplicationSuccessPage = lazy(() => import('../pages/application-success/page'));
const TechnicalSupportPage = lazy(() => import('../pages/technical-support/page'));
const MaintenanceInquiryPage = lazy(() => import('../pages/maintenance-inquiry/page'));
const MaintenanceInquirySuccessPage = lazy(() => import('../pages/maintenance-inquiry-success/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '/application-success',
    element: <ApplicationSuccessPage />,
  },
  {
    path: '/technical-support',
    element: <TechnicalSupportPage />,
  },
  {
    path: '/maintenance-inquiry',
    element: <MaintenanceInquiryPage />,
  },
  {
    path: '/maintenance-inquiry-success',
    element: <MaintenanceInquirySuccessPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
